import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/green_check_circle_64.png'
import _imports_1 from '@/assets/logos/Facebook.png'
import _imports_2 from '@/assets/logos/Discord.svg'
import _imports_3 from '@/assets/logos/X.png'


const _withScopeId = n => (_pushScopeId("data-v-15fd0d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Checkmark"
  }),
  /*#__PURE__*/_createElementVNode("div", null, " Great! You're signed up for the preview. We'll send you an email as soon as you're in. "),
  /*#__PURE__*/_createElementVNode("div", { class: "link-section" }, [
    /*#__PURE__*/_createElementVNode("div", null, " Meanwhile, check us out on social media, and feel free to ask any questions you have! "),
    /*#__PURE__*/_createElementVNode("div", { class: "links" }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.facebook.com/groups/1484810245417258" }, [
        /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
      ]),
      /*#__PURE__*/_createElementVNode("a", { href: "https://discord.gg/mFkGM5fH7b" }, [
        /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
      ]),
      /*#__PURE__*/_createElementVNode("a", { href: "https://x.com/treecrossing" }, [
        /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
      ])
    ])
  ])
], -1))

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useSignInStore } from '@webapp/auth/SignInStore'
import TaskPage from '@webapp/util/TaskPage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpDonePage',
  setup(__props) {

const signInStore = useSignInStore()
const router = useRouter()

onMounted(() => {
  if (!signInStore.subject) {
    router.replace('/signup')
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TaskPage, {
    class: "signup-later-page",
    "no-back": "",
    "no-action": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Get started")
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})